<template lang="html">
  <div id="company-page">

    <section class="main-section">
      <!-- <div class="placed-backg box-image"></div> -->

      <div class="box-image-left">
        <div class="img"></div>
        <img src="public/images/pages/company/image.jpg">
      </div>

      <div class="container oversized-container">
        <div class="row">
          <div class="col-lg-5 col-xl-6 col-image"></div>

          <div class="col-lg-7 col-xl-6 col-text">
            <h1 class="mb-2 title">¿Quienes somos?</h1>

            <!-- <h5 class="subtitle"></h5> -->
            <p>
              Somos una empresa familiar orgullosamente mexicana dedicada a la fabricación de productos de plástico involucrada con la satisfacción de los clientes pero también siempre preocupados por la utilización del plastico sin contaminar nuestro medio ambiente, producimos productos para la naturaleza y en la mayoría de nuestros procesos usamos materiales reciclados para el mejor aprovechamiento de los recursos naturales e industriales reincorporando desechos plásticos a una nueva vida  útil.
            </p>

            <p class="mt-3">
              Fabricamos productos basados en la funcionalidad y comodidad, garantizando que éstos sean altamente competitivos. El perseguir nuestras metas día con día y el que diariamente avancemos en nuestros propósitos constituye nuestra razón de ser como empresa.
            </p>

            <p class="mt-3">
              Nuestros Principios y Valores son los que nos dan la Personalidad, la forma de ser.
            </p>
          </div>
        </div>
      </div>
    </section>

    <section class="info-section">
      <div class="container">
        <!-- <h2 class="text-center title-2">Nuestro ADN</h2> -->

        <div class="row row-content">
          <div class="col-lg-3 col-title">
            <h5 class="title">MISIÓN</h5>
          </div>

          <div class="col-lg-9 col-text">
            <p class="mb-3">
              Llevar al mercado productos de calidad, manteniendo una permanente superación tecnológica que nos permita ofrecer cada vez mayores ventajas en lo que se refiere al uso de materiales termoplásticos para la Industria, así como satisfacer los requerimientos de nuestros clientes en las áreas de las maquilas y la agricultura.
            </p>
            <p class="mb-3">
              Contribuir de manera importante en el desarrollo económico y social de nuestra comunidad, mediante el compromiso individual de todos nuestros colaboradores, favoreciendo su crecimiento profesional y distinguiéndonos como una empresa socialmente responsable.
            </p>
            <p>
              Mejorar el aprovechamiento de recursos naturales he industriales al re introducir desechos plásticos a un nuevo ciclo de vida útil.
            </p>
          </div>
        </div>

        <div class="row row-content">
          <div class="col-lg-3 col-title">
            <h5 class="title">VISIÓN</h5>
          </div>

          <div class="col-lg-9 col-text">
            <p>
              Ser la empresa más competitiva, dinámica e innovadora en el sector industrial del plástico, que tanto los clientes como los proveedores y empleados se sientan orgullosos de nuestros productos.
            </p>
          </div>
        </div>

        <div class="row row-content">
          <div class="col-lg-3 col-title">
            <h5 class="title">VALORES</h5>
          </div>

          <div class="col-lg-9 col-text">
            <p>
              Fiabilidad, seriedad, honestidad, conocimiento, accesibilidad, rapidez atención en el servicio, iniciativa, mejora continua, promoción de cambio y trabajo en equipo son los valores que en procesos plásticos inyectados nos motivan y ayudan a seguir adelante.
            </p>
          </div>
        </div>
      </div>
    </section>

    <section class="history-section">
      <div class="container">
        <h2 class="text-center title-2">Nuestra historia</h2>

        <div class="box-content">
          <p class="mb-3">
            Procesos Plásticos Inyectados S.A de C.V. es una empresa orgullosamente mexicana y fundada en 1987 dedicada a la transformación de plástico por inyección, está situado en la colonia ferrocarril cerca de la zona industrial de Guadalajara, Jalisco. México.
          </p>

          <p class="mb-3">
            Contamos con la maquinaria y tecnología necesarias así como con el personal calificado, para aplicar procedimientos de calidad a lo largo de todo el proceso productivo, siendo la principal meta una total satisfacción del cliente.
          </p>

          <p>
            En el año 2002 creamos la división Jardinería-Artesanal con una serie de macetas que pretenden ser innovadoras y diferentes a las demás y de igual manera que sean únicas ya que combinamos las antiguas técnicas artesanales con los materiales y tecnología más modernas para fabricar macetas en serie pero con un toque personal y con calidad manual y plásticas de nuestros trabajadores.
          </p>

          <p>
            En la actualidad nos encontramos presentes en el mercado en dos campos: La fabricación de productos plásticos propios y la inyección de plásticos a terceros y para la industria.
          </p>
        </div>
      </div>
    </section>

    <section class="extra-section">
      <div class="container">
        <h2 class="text-center title-2">Algunos de los mercados a los que atendemos son</h2>

        <div class="row">
          <div class="col-sm-6 col-lg-3 col-info">
            <div class="box-icon">
              <img src="public/images/pages/company/icon-1.png">
            </div>

            <h5>Automotriz</h5>
            <!-- <p>
              Accede a todo el contenido sin restricciones por una tarifa fija.
            </p> -->
          </div>

          <div class="col-sm-6 col-lg-3 col-info">
            <div class="box-icon">
              <img src="public/images/pages/company/icon-2.png">
            </div>

            <h5>Electrodoméstico</h5>
            <!-- <p>
              Accede a todo el contenido sin restricciones por una tarifa fija.
            </p> -->
          </div>

          <div class="col-sm-6 col-lg-3 col-info">
            <div class="box-icon">
              <img src="public/images/pages/company/icon-3.png">
            </div>

            <h5>Juguete</h5>
            <!-- <p>
              Agregamos nuevas ideas y estrategias regularmente.
            </p> -->
          </div>

          <div class="col-sm-6 col-lg-3 col-info">
            <div class="box-icon">
              <img src="public/images/pages/company/icon-4.png">
            </div>

            <h5>Artículos del hogar</h5>
            <!-- <p>
              Agregamos nuevas ideas y estrategias regularmente.
            </p> -->
          </div>
        </div>
      </div>
    </section>

  </div>
</template>

<script>
export default {
}
</script>
